import MarkAsCompleteTask from '../common/tasks/MarkAsCompleteTask';
import { ApproveDataTask } from './tasks/ApproveDataTask';
import { UpdateDataTask } from './tasks/UpdateDataTask';
import { UploadAcknowledgementTask } from './tasks/UploadAcknowledgementTask';
import { VatReturnFilingDefaultTasks } from './vat-return-filing-default';

export const VAT_RETURN_FILING_DEFAULT_COMPONENT_MAP = {
  [VatReturnFilingDefaultTasks.START_PREPARATION]: MarkAsCompleteTask,
  [VatReturnFilingDefaultTasks.UPDATE_DATA]: UpdateDataTask,
  [VatReturnFilingDefaultTasks.APPROVE_DATA]: ApproveDataTask,
  [VatReturnFilingDefaultTasks.MARK_FILING_COMPLETE]: MarkAsCompleteTask,
  [VatReturnFilingDefaultTasks.UPLOAD_ACKNOWLEDGEMENT]:
    UploadAcknowledgementTask,
};
